import { FacetNavigation } from "./Sidebar/Filters";
import { getParamValueFromUrl } from "./Sidebar/FilterUrlHelpers";

export default (
  {
    appliedFacetValues: {
      categoryFacets,
      brandFacets,
      partsFacets,
      searchWithinFacets,
      specificationFacets,
      priceFacets,
    },
  }: FacetNavigation,
  ignoreCategoryFacets = false,
  pageUrl?: string
): boolean =>
  (!ignoreCategoryFacets && categoryFacets.length > 0) ||
  brandFacets.length > 0 ||
  partsFacets.length > 0 ||
  priceFacets.length > 0 ||
  searchWithinFacets.length > 0 ||
  specificationFacets.length > 0 ||
  !!(pageUrl && getParamValueFromUrl(pageUrl, "manufacturer"));
